const ONE_LINE_CLASS = "variant-label-one-line";
const TWO_LINES_CLASS = "variant-label-two-lines";

function getLineCount(el: HTMLElement): number {
  const style = window.getComputedStyle(el);
  const lineHeight = style.lineHeight;
  const fontSize = parseFloat(style.fontSize);
  const lineHeightPx = lineHeight === "normal" ? fontSize * 1.2 : parseFloat(lineHeight);
  const scrollHeight = el.scrollHeight;
  const lines = Math.round(scrollHeight / lineHeightPx) || 1;
  return Math.max(1, lines);
}

function applyPaddingClass(el: HTMLElement): void {
  const lines = getLineCount(el);
  el.classList.remove(ONE_LINE_CLASS, TWO_LINES_CLASS);
  el.classList.add(lines === 1 ? ONE_LINE_CLASS : TWO_LINES_CLASS);
}

function initVariantOptionLabelPadding(root: ParentNode = document): void {
  const labels = root.querySelectorAll<HTMLElement>("[data-variant-option-label]");
  for (const label of labels) {
    applyPaddingClass(label);
  }
}

let resizeTimeout: ReturnType<typeof setTimeout> | null = null;

function onResize(): void {
  if (resizeTimeout) clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    initVariantOptionLabelPadding();
    resizeTimeout = null;
  }, 50);
}

export function initVariantOptionLabelPaddingModule(): void {
  initVariantOptionLabelPadding();
  window.addEventListener("resize", onResize);
  if (document.readyState === "complete") {
    onResize();
  } else {
    window.addEventListener("load", onResize);
  }
}

export function initVariantOptionLabelPaddingInContext(root: ParentNode): void {
  initVariantOptionLabelPadding(root);
}
